// extracted by mini-css-extract-plugin
module.exports = {"container":"Navigation_container__MiJ6i","menuItem":"Navigation_menuItem__leIan","item":"Navigation_item__9vEqk"};